
export default function IconDashbord() {
  return (
    <svg
      id="fi_9338878"
      height="512"
      viewBox="0 0 32 32"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m1 29h30v2h-30z"></path>
      <path d="m5.5 12a1.5 1.5 0 0 0 -1.5 1.5v13.5h6v-13.5a1.5 1.5 0 0 0 -1.5-1.5z"></path>
      <path d="m14.5 20a1.5 1.5 0 0 0 -1.5 1.5v5.5h6v-5.5a1.5 1.5 0 0 0 -1.5-1.5z"></path>
      <path d="m23.5 23a1.5 1.5 0 0 0 -1.5 1.5v2.5h6v-2.5a1.5 1.5 0 0 0 -1.5-1.5z"></path>
      <path d="m13.3 14.08a6.91 6.91 0 0 0 4.7 4.65 7.48 7.48 0 0 0 2 .27 7 7 0 0 0 7-7 1 1 0 0 0 -1-1h-3.5a1.5 1.5 0 0 1 -1.5-1.5v-3.5a1 1 0 0 0 -1-1 7 7 0 0 0 -5.45 2.59 7.08 7.08 0 0 0 -1.25 6.49z"></path>
      <path d="m24 9h6a1 1 0 0 0 1-1 7 7 0 0 0 -7-7 1 1 0 0 0 -1 1v5.51c0 1.04.45 1.49 1 1.49z"></path>
      <path d="m1 1h14v2h-14z"></path>
      <path d="m1 5h9v2h-9z"></path>
    </svg>
  );
}
